/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ProductType {
  PV = 0,
  Storage = 1,
  'Power Electronic' = 2,
  Inspection = 3,
  Permitting = 4,
  Electrical = 5,
  'Electrical Panel Upgrade' = 6,
  'Site Survey' = 7,
  'Program Management' = 8,
  Kit = 9,
  'Asphalt Shingle' = 10,
  'Ridge Cap' = 11,
  Warranty = 12,
}
